import React, { useEffect } from "react";

const Location = () => {
  useEffect(() => {
    // Load Elfsight platform script once
    if (!document.getElementById("elfsight-platform-script")) {
      const script = document.createElement("script");
      script.id = "elfsight-platform-script";
      script.src = "https://elfsightcdn.com/platform.js";
      script.async = true;
      script.onload = () => {
        if (window.ElfsightPlatform) {
          window.ElfsightPlatform.init();
        }
      };
      document.body.appendChild(script);
    } else {
      // Reinitialize if already loaded
      if (window.ElfsightPlatform) {
        window.ElfsightPlatform.init();
      }
    }
  }, []);
  

  return (
    <section
      data-aos="fade-up"
      className="bg-white py-6 px-4 md:py-10 md:px-12 text-center"
    >
      {/* Elfsight Google Reviews */}
      <div class="elfsight-app-4baa9041-e390-46ad-8c00-5878fc83b407" data-elfsight-app-lazy></div>


      {/* Google Map */}
      <div className="relative w-full overflow-hidden">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3987.5070897292544!2d30.05688147361064!3d-1.9503101367095377!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19dca425f50b9907%3A0x727b3786b7a4d643!2sEye%20Care%20Optical%20Ltd.%20-%20Eye%20Care%20Centre%20Rwanda-%20Opticians%20in%20Rwanda!5e0!3m2!1sen!2sin!4v1755153208969!5m2!1sen!2sin"
          className="w-full rounded-2xl"
          style={{
            height: "350px",
            border: 0,
            margin: 0,
            padding: 0,
          }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Eye Care Optical Map"
        />
      </div>
    </section>
  );
};

export default Location;
